import React from "react";
import { Space } from "antd";
import { RocketTwoTone } from "@ant-design/icons";
import styles from "./PremiumFeatures.module.scss";
import LinkOrSpan from "@/components/links/LinkOrSpan/LinkOrSpan";

function PremiumSidebar() {
  return (
    <LinkOrSpan to={"/explore_features"}>
      <Space className={styles.premiumSideBar}>
        <div className={styles.iconContainer}>
          <RocketTwoTone twoToneColor={["#1890FF", "#CDEAFF"]} />
        </div>

        <span className={styles.text}>Explore features</span>
      </Space>
    </LinkOrSpan>
  );
}

export default PremiumSidebar;
